export enum DashboardViews {
    SentToDoctor = "Sent to Doctor",
    ToBeApprove = "To be Approve",
    Active = "Active",
    InActive = "In-Active",
}


